import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-global',
  templateUrl: './global.component.html',
  styleUrls: ['./global.component.scss']
})
export class GlobalComponent implements OnInit {


public static appsrcURL: string = "https://developmentapi.getyourvendor.com/public";
// public static appsrcURL: string = "https://app.getyourvendor.com/public";
//public static hostName: string ="https://getyourvendor.com";
//public static hostName: string ="localhost:4200";

public static hostName: string = "https://development.getyourvendor.com";
  constructor() { }

  ngOnInit(): void {
  }

}